import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

// The old journal-entry engine that used to live here was never called by any
// screen (all posting goes through transactionHelper) and has been removed.
// Only this lookup is still used (Fixed Assets).

/**
 * Find a system account by its code
 */
export const findAccountByCode = async (companyId, code) => {
  const ref = collection(db, 'companies', companyId, 'accounts');
  const q = query(ref, where('code', '==', code));
  const snapshot = await getDocs(q);
  if (snapshot.empty) return null;
  return { id: snapshot.docs[0].id, ...snapshot.docs[0].data() };
};
